import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { EngineService } from './engine.service';
import * as THREE from 'three';

@Component({
    selector: 'app-animatrix',
    templateUrl: './animatrix.component.html',
    styleUrls: ['./animatrix.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnimatrixComponent implements OnInit {
  @ViewChild('rendererCanvas', { static: true })
  public rendererCanvas: ElementRef<HTMLCanvasElement>;
  private modelName;

  public constructor(private engServ: EngineService) {}

  public ngOnInit(): void {
    this.engServ.createScene(this.rendererCanvas);
    setTimeout(() => {
      this.engServ.render();
    }, 100);
  }

  uploadModel(event) {
    console.log(event.target.files[0]);
    this.modelName = event.target.files[0].name.replace(/\.[^/.]+$/, '');
    const url = URL.createObjectURL(event.target.files[0]);
    this.engServ.loadModel(url);
  }

  uploadScene(event) {
    const url = URL.createObjectURL(event.target.files[0]);
    const image = new Image();
    image.src = url;
    image.addEventListener('load', () => {
      console.log(image.width);
      console.log(image.height);
      // document.getElementById(
      //   'renderCanvas'
      // ).style.backgroundImage = `url(${url})`;

      console.log(this.rendererCanvas.nativeElement);
      const loader = new THREE.TextureLoader();
      const bgTexture = loader.load(url, () => {
        this.engServ.scene.background = bgTexture;
        this.engServ.render();
      });
      this.engServ.renderer.setSize(image.width, image.height);
    });
  }

  updateTexture(e) {
    console.log(e);
    this.engServ.loadTexture(e);
  }

  download() {
    const MIME_TYPE = 'image/jpeg';

    const imgURL = this.rendererCanvas.nativeElement.toDataURL(MIME_TYPE, 0.8);

    const dlLink = document.createElement('a');
    dlLink.download = this.modelName;
    dlLink.href = imgURL;
    dlLink.dataset.downloadurl = [MIME_TYPE, dlLink.download, dlLink.href].join(
      ':'
    );

    document.body.appendChild(dlLink);
    dlLink.click();
    document.body.removeChild(dlLink);
  }
}
